<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增运费设置</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="shippinglist.length > 1 ? shippinglist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'清空已填模板',type:'del'}" @finish="Delshipping(-1)"/>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'新增设置',type:'del'}" @finish="AddShipping"/>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回设置管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsShipping'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in shippinglist" :key="index">
            <div class="TTL-form-submit-box-title">运费设置-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="shippinglist.length > 1" @click.stop="Delshipping(index)">删除</el-button>
            </div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">运费设置名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入运费名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.name=val.value;
                                SaveDataToBrowser();
                            }
                            if(val.type=='change') {
                                item.name=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">运费类型<i>*</i></label>
                    <wcselect :option="{placeholder:'配送类型',ischange:true,width:'170px',clearable:true,filterable:true}" 
                        :value="item.type"
                        :list="typelist"
                        @finish="(val)=> {
                            item.type=val.value;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item v-if="item.type==1">
                    <label class="TTL-form-label">距离/重量/体积-金额设置<i>*</i></label>
                    <div class="TTL-setting-info">
                        <span class="TTL-setting-info-title right10">小于等于</span>
                        <wcinputprex :option="{isinput:true,childname:'km',width:'170px'}"
                            :value="item.lowvalue"
                            @finish="(val)=> {
                                item.lowvalue=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.price"
                            @finish="(val)=> {
                                item.price=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，每增加</span>
                        <wcinputprex :option="{isinput:true,childname:'km',width:'170px'}"
                            :value="item.unitvalue"
                            @finish="(val)=> {
                                item.unitvalue=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，金额增加</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.unitprice"
                            @finish="(val)=> {
                                item.unitprice=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                    </div>
                </el-form-item>
                <el-form-item v-if="item.type==2">
                    <label class="TTL-form-label">距离/重量/体积-金额设置<i>*</i></label>
                    <div class="TTL-setting-info">
                        <span class="TTL-setting-info-title right10">小于等于</span>
                        <wcinputprex :option="{isinput:true,childname:'kg',width:'170px'}"
                            :value="item.lowvalue"
                            @finish="(val)=> {
                                item.lowvalue=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.price"
                            @finish="(val)=> {
                                item.price=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，每增加</span>
                        <wcinputprex :option="{isinput:true,childname:'kg',width:'170px'}"
                            :value="item.unitvalue"
                            @finish="(val)=> {
                                item.unitvalue=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，金额增加</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.unitprice"
                            @finish="(val)=> {
                                item.unitprice=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                    </div>
                </el-form-item>
                <el-form-item v-if="item.type==3">
                    <label class="TTL-form-label">距离/重量/体积-金额设置<i>*</i></label>
                    <div class="TTL-setting-info">
                        <span class="TTL-setting-info-title right10">小于等于</span>
                        <wcinputprex :option="{isinput:true,childname:'m³',width:'170px'}"
                            :value="item.lowvalue"
                            @finish="(val)=> {
                                item.lowvalue=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.price"
                            @finish="(val)=> {
                                item.price=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，每增加</span>
                        <wcinputprex :option="{isinput:true,childname:'m³',width:'170px'}"
                            :value="item.unitvalue"
                            @finish="(val)=> {
                                item.unitvalue=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，金额增加</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.unitprice"
                            @finish="(val)=> {
                                item.unitprice=val.value;
                                SaveDataToBrowser();
                            }"
                        />
                    </div>
                </el-form-item>

            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_SHIPPING from '@/Interface/Es/shipping';
export default {
    components:{},
    data() {
        return {
            Browser:'addshipping',
            loadingobj:'addshipping',
            limit:10,  //限制添加数据条数
            memberinfo:{name:'',type:1,lowvalue:'',heightvalue:'',price:'',unit:'km',unitvalue:'',unitprice:''}, //设置模板信息           
            shippinglist:[], //续费设置
            typelist:[],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.ParseData();  //解析之前填写的数据
            this.GetShippingType(isfresh);
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.shippinglist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个设置',type:'warning'});return false;}
            var data=[];
            for(var i in this.shippinglist) data.push(this.shippinglist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHIPPING.ADD_SHIPPING({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.ResetParam(); //重置数据
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 新增模板信息 **/
        AddShipping() {
            if(this.shippinglist.length >= this.limit) {this.$notice({title:'错误提示',message:'新增模板数量不能超过'+this.limit+'个',type:'warning'});return false;}
            var dateinfo={};
            for(var i in this.memberinfo) dateinfo[i]=this.memberinfo[i];
            this.shippinglist.push(dateinfo);
            this.SaveDataToBrowser();
        },


        /** 删除模板信息 **/
        Delshipping(index) {

            //删除单个模板信息时，无需询问，直接删除
            if(index >=0) {
                this.shippinglist.splice(index,1);
                this.SaveDataToBrowser();
                return false;
            } 

            //删除全部模板时先询问再操作
            this.$confirm.confirm(
                '您是否确定要删除当前所有模板文件信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.ResetParam();
            }).catch(()=> {

            });
        },   


        /** 数据重置 **/
        ResetParam() {
             this.shippinglist=[];
             this.AddShipping();
        },


        /** 缓存数据到浏览器 **/
        SaveDataToBrowser() {
            this.$LOCALDATA.SetBrowData(this.Browser,this.shippinglist);
        },


        /** 从浏览器提取数据解析 **/
        ParseData() {
            this.shippinglist=this.$LOCALDATA.GetBrowData(this.Browser);
            if(this.shippinglist.length==0) this.AddShipping();
        },


         /** 获取运费类型 **/
        GetShippingType(isfresh) {
            this.$method.GET_SHIPPING_TYPE(isfresh).then((res) => {this.typelist=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
.TTL-setting-info {display: inline-flex;width:100%;align-items: center;}
.TTL-setting-info-title {font-size:13px;}
</style>